export function dummyData() {
  const now = new Date()
  const d = (days) => new Date(now - days * 86400000)

  return [
    // Root folders
    { id: 'f1', name: 'Proyectos', type: 'folder', parent_id: null, created_at: d(120), updated_at: d(2), size: 0 },
    { id: 'f2', name: 'Diseño', type: 'folder', parent_id: null, created_at: d(90), updated_at: d(5), size: 0 },
    { id: 'f3', name: 'Documentos', type: 'folder', parent_id: null, created_at: d(200), updated_at: d(1), size: 0 },
    { id: 'f4', name: 'Recursos', type: 'folder', parent_id: null, created_at: d(60), updated_at: d(10), size: 0 },
    { id: 'f5', name: 'Archivos personales', type: 'folder', parent_id: null, created_at: d(300), updated_at: d(30), size: 0 },

    // Root files
    { id: 'r1', name: 'README.md', type: 'file', ext: 'md', parent_id: null, created_at: d(180), updated_at: d(3), size: 4200 },
    { id: 'r2', name: 'notas.txt', type: 'file', ext: 'txt', parent_id: null, created_at: d(10), updated_at: d(0), size: 1024 },
    { id: 'r3', name: 'presupuesto_2024.xlsx', type: 'file', ext: 'xlsx', parent_id: null, created_at: d(15), updated_at: d(4), size: 52400 },
    { id: 'r4', name: 'foto_perfil.png', type: 'file', ext: 'png', parent_id: null, created_at: d(50), updated_at: d(50), size: 348000 },

    // Proyectos subfolders
    { id: 'f1a', name: 'Web App', type: 'folder', parent_id: 'f1', created_at: d(100), updated_at: d(1), size: 0 },
    { id: 'f1b', name: 'Mobile App', type: 'folder', parent_id: 'f1', created_at: d(80), updated_at: d(7), size: 0 },
    { id: 'f1c', name: 'Backend API', type: 'folder', parent_id: 'f1', created_at: d(70), updated_at: d(2), size: 0 },

    // Proyectos files
    { id: 'p1', name: 'roadmap.pdf', type: 'file', ext: 'pdf', parent_id: 'f1', created_at: d(90), updated_at: d(5), size: 245000 },
    { id: 'p2', name: 'sprint_backlog.xlsx', type: 'file', ext: 'xlsx', parent_id: 'f1', created_at: d(14), updated_at: d(1), size: 38000 },
    { id: 'p3', name: 'arquitectura.png', type: 'file', ext: 'png', parent_id: 'f1', created_at: d(60), updated_at: d(60), size: 512000 },

    // Web App files
    { id: 'w1', name: 'App.vue', type: 'file', ext: 'vue', parent_id: 'f1a', created_at: d(99), updated_at: d(1), size: 8400 },
    { id: 'w2', name: 'package.json', type: 'file', ext: 'json', parent_id: 'f1a', created_at: d(99), updated_at: d(3), size: 1200 },
    { id: 'w3', name: 'index.html', type: 'file', ext: 'html', parent_id: 'f1a', created_at: d(99), updated_at: d(10), size: 2100 },
    { id: 'w4', name: 'styles.css', type: 'file', ext: 'css', parent_id: 'f1a', created_at: d(95), updated_at: d(2), size: 15600 },

    // Diseño files
    { id: 'd1', name: 'brand_guide.pdf', type: 'file', ext: 'pdf', parent_id: 'f2', created_at: d(85), updated_at: d(20), size: 4200000 },
    { id: 'd2', name: 'logo_v3.svg', type: 'file', ext: 'svg', parent_id: 'f2', created_at: d(45), updated_at: d(45), size: 28000 },
    { id: 'd3', name: 'mockup_home.fig', type: 'file', ext: 'fig', parent_id: 'f2', created_at: d(30), updated_at: d(8), size: 18900000 },
    { id: 'd4', name: 'iconos.zip', type: 'file', ext: 'zip', parent_id: 'f2', created_at: d(40), updated_at: d(40), size: 890000 },
    { id: 'd5', name: 'paleta_colores.pdf', type: 'file', ext: 'pdf', parent_id: 'f2', created_at: d(55), updated_at: d(55), size: 120000 },

    // Documentos files
    { id: 'doc1', name: 'contrato_servicio.docx', type: 'file', ext: 'docx', parent_id: 'f3', created_at: d(150), updated_at: d(15), size: 94000 },
    { id: 'doc2', name: 'NDA_cliente.pdf', type: 'file', ext: 'pdf', parent_id: 'f3', created_at: d(120), updated_at: d(120), size: 180000 },
    { id: 'doc3', name: 'propuesta_comercial.pptx', type: 'file', ext: 'pptx', parent_id: 'f3', created_at: d(25), updated_at: d(3), size: 3400000 },
    { id: 'doc4', name: 'acta_reunion_ene.docx', type: 'file', ext: 'docx', parent_id: 'f3', created_at: d(48), updated_at: d(48), size: 42000 },

    // Recursos files
    { id: 'res1', name: 'fuentes.zip', type: 'file', ext: 'zip', parent_id: 'f4', created_at: d(58), updated_at: d(58), size: 12400000 },
    { id: 'res2', name: 'stock_foto_01.jpg', type: 'file', ext: 'jpg', parent_id: 'f4', created_at: d(35), updated_at: d(35), size: 2100000 },
    { id: 'res3', name: 'stock_foto_02.jpg', type: 'file', ext: 'jpg', parent_id: 'f4', created_at: d(35), updated_at: d(35), size: 1900000 },
    { id: 'res4', name: 'video_intro.mp4', type: 'file', ext: 'mp4', parent_id: 'f4', created_at: d(20), updated_at: d(20), size: 48000000 },

    // Archivos personales
    { id: 'per1', name: 'cv_2024.pdf', type: 'file', ext: 'pdf', parent_id: 'f5', created_at: d(180), updated_at: d(60), size: 320000 },
    { id: 'per2', name: 'foto_vacaciones.jpg', type: 'file', ext: 'jpg', parent_id: 'f5', created_at: d(200), updated_at: d(200), size: 4800000 },
    { id: 'per3', name: 'playlist.m3u', type: 'file', ext: 'm3u', parent_id: 'f5', created_at: d(90), updated_at: d(5), size: 3200 },
  ]
}

export function formatSize(bytes) {
  if (!bytes) return '—'
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  if (bytes < 1024 * 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1) + ' MB'
  return (bytes / 1024 / 1024 / 1024).toFixed(2) + ' GB'
}

export function formatDate(date) {
  if (!date) return '—'
  const d = new Date(date)
  const now = new Date()
  const diff = (now - d) / 1000
  if (diff < 60) return 'Ahora mismo'
  if (diff < 3600) return Math.floor(diff / 60) + ' min'
  if (diff < 86400) return Math.floor(diff / 3600) + 'h'
  if (diff < 86400 * 7) return Math.floor(diff / 86400) + 'd'
  return d.toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' })
}

export const FILE_ICONS = {
  folder: { icon: '📁', color: '#fbbf24' },
  pdf:    { icon: '📄', color: '#f87171' },
  doc:    { icon: '📝', color: '#60a5fa' },
  docx:   { icon: '📝', color: '#60a5fa' },
  xls:    { icon: '📊', color: '#4ade80' },
  xlsx:   { icon: '📊', color: '#4ade80' },
  ppt:    { icon: '📑', color: '#fb923c' },
  pptx:   { icon: '📑', color: '#fb923c' },
  png:    { icon: '🖼️', color: '#c084fc' },
  jpg:    { icon: '🖼️', color: '#c084fc' },
  jpeg:   { icon: '🖼️', color: '#c084fc' },
  gif:    { icon: '🖼️', color: '#c084fc' },
  svg:    { icon: '✏️', color: '#34d399' },
  mp4:    { icon: '🎬', color: '#f472b6' },
  mp3:    { icon: '🎵', color: '#a78bfa' },
  m3u:    { icon: '🎵', color: '#a78bfa' },
  zip:    { icon: '📦', color: '#94a3b8' },
  rar:    { icon: '📦', color: '#94a3b8' },
  json:   { icon: '{ }', color: '#fbbf24' },
  js:     { icon: 'JS', color: '#fbbf24' },
  ts:     { icon: 'TS', color: '#60a5fa' },
  vue:    { icon: '⬡', color: '#4ade80' },
  html:   { icon: '🌐', color: '#fb923c' },
  css:    { icon: '🎨', color: '#60a5fa' },
  md:     { icon: '📋', color: '#94a3b8' },
  txt:    { icon: '📃', color: '#94a3b8' },
  fig:    { icon: '◈', color: '#a78bfa' },
  default:{ icon: '📄', color: '#64748b' },
}

export function getFileIcon(item) {
  if (item.type === 'folder') return FILE_ICONS.folder
  const ext = (item.ext || '').toLowerCase()
  return FILE_ICONS[ext] || FILE_ICONS.default
}
